import script from "./dayCollectionWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./dayCollectionWidget.vue?vue&type=script&setup=true&lang=js"

import "./dayCollectionWidget.vue?vue&type=style&index=0&id=4914a79f&lang=scss"

const __exports__ = script;

export default __exports__